import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    useCallback,
} from 'react';
import { getBanners } from '../../api/api';
import { normalizePriority, PRIORITY_ORDER } from './bannerUtils';

const BannerContext = createContext({
    banners: [],
    loaded: false,
    refresh: () => {},
});

export const useBanners = () => useContext(BannerContext);

export const BannerProvider = ({ children }) => {
    const [banners, setBanners] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const loadBanners = useCallback(async () => {
        try {
            const response = await getBanners();
            if (!response) return;
            const data = await response.json();

            const active = data
                .filter(
                    (b, i, arr) => arr.findIndex((x) => x.id === b.id) === i
                )
                .map((b) => ({ ...b, priority: normalizePriority(b.priority) }))
                .filter((b) => b.activeStatus === 'Active')
                .sort(
                    (a, b) =>
                        (PRIORITY_ORDER[a.priority] || 99) -
                        (PRIORITY_ORDER[b.priority] || 99)
                );

            setBanners(active);
        } catch (e) {
            console.log('Failed to load banners:', e);
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        loadBanners();
        const interval = setInterval(loadBanners, 30000);
        return () => clearInterval(interval);
    }, [loadBanners]);

    return (
        <BannerContext.Provider
            value={{ banners, loaded, refresh: loadBanners }}
        >
            {children}
        </BannerContext.Provider>
    );
};
